export default __webpack_public_path__ + "static/media/video.92f7ec9f.mp4";